import { ParseError } from '../errors'
import { type AccountData, emptyAccount } from '../models'

export function splitPipeRecords(data: string): string[] {
  return data
    .trim()
    .split('\n')
    .map((l) => l.trim())
    .filter((l) => l.length > 0)
}

function looksLikeCookies(s: string): boolean {
  return s.includes('sessionid=') || s.includes('ds_user_id=')
}

export function canParsePipe(data: string): boolean {
  for (const raw of data.trim().split('\n')) {
    const line = raw.trim()
    if (!line) continue
    const parts = line.split('|')
    if (parts.length < 5 || parts.length > 6) return false
    if (!parts[0].includes(':')) return false
    const cookieIdx = parts.length === 6 ? 3 : 2
    return looksLikeCookies(parts[cookieIdx])
  }
  return false
}

export function parsePipe(record: string): AccountData {
  const parts = record.trim().split('|')
  if (parts.length < 5 || parts.length > 6) {
    throw new ParseError(`Expected 5 or 6 pipe-separated parts, got ${parts.length}`)
  }

  const isExtended = parts.length === 6
  const loginPass2fa = parts[0]
  const ua = parts[1] ?? ''
  const androidId = isExtended ? (parts[2] ?? '') : ''
  const cookieStr = isExtended ? (parts[3] ?? '') : (parts[2] ?? '')
  const proxy = isExtended ? (parts[4] ?? '') : (parts[3] ?? '')
  const emailPass = isExtended ? (parts[5] ?? '') : (parts[4] ?? '')

  const lp = loginPass2fa.split(':')
  if (lp.length < 2) throw new ParseError(`Cannot parse login:pass from: ${loginPass2fa}`)
  const login = lp[0]
  const password = lp[1]
  const twofaKey = lp[2] ?? ''

  const cookies: Record<string, string> = {}
  for (const headerRaw of cookieStr.split(';')) {
    const eq = headerRaw.indexOf('=')
    if (eq <= 0) continue
    const key = headerRaw.slice(0, eq).trim()
    const value = headerRaw.slice(eq + 1).trim()
    if (key) cookies[key] = value
  }

  let emailLogin = ''
  let emailPassword = ''
  if (emailPass.includes(':')) {
    const idx = emailPass.indexOf(':')
    emailLogin = emailPass.slice(0, idx)
    emailPassword = emailPass.slice(idx + 1)
  } else if (emailPass) {
    emailLogin = emailPass
  }

  return {
    ...emptyAccount(),
    login,
    password,
    twofaKey,
    cookies,
    userAgent: ua,
    proxy,
    emailLogin,
    emailPassword,
    androidId,
  }
}
